import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry } from 'rxjs';
import { LU_STUnitOfMeasure } from 'scaletech-core';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_UnitOfMeasureService extends StarbaseDataService<LU_STUnitOfMeasure> {
  protected _staleDataTimeout = 30000;
  protected _getOneUri = '/api/LU_UnitOfMeasure/';
  protected _getAllUri = '/api/LU_UnitOfMeasure';
  protected _postUri = '/api/LU_UnitOfMeasure';
  protected _putUri = '/api/LU_UnitOfMeasure/';
  protected _deleteUri = '/api/LU_UnitOfMeasure/';
  protected _broadSearchUri = '/api/LU_UnitOfMeasure/GetUnitsOfMeasureByFilterParams';

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<LU_STUnitOfMeasure>): Observable<FilterParams<LU_STUnitOfMeasure>> {
    filterParams.collection = [];
    return this._http.post<FilterParams<LU_STUnitOfMeasure>>(
      this.server + url, filterParams, { headers: this._webAPI.getApiHeaders('post')}
    ).pipe(retry(this.defaultRetries),
      catchError(e => this._webAPI.handleRequestError(e)));
  }

  getDataSource() {
    return this._http.get<any[]>(this.server + this._getAllUri, {headers: this._webAPI.getApiHeaders('get')});
  }

  /** In order to properly display Last Modifed date we must override the primary getter to manually set Last Modified Date to null */
  public getAllData(url: string, retryCount?: number): Observable<LU_STUnitOfMeasure[]> {
    return super.getAllData(url, retryCount).pipe(
      map((l: LU_STUnitOfMeasure[]) =>
        l.map(
          (lu: LU_STUnitOfMeasure) => {
            if (lu.lastModifiedDateTime) {
              const date = new Date(lu.lastModifiedDateTime);
              const year = date.getFullYear();
              if (year === 1 || year === 0) {
                lu.lastModifiedDateTime = null;
              }
            }

            return lu;
          })
      ));
  }

  /** Since Last Modified Date is set to null during get we must set it to a value when saving to prevent errors. */
  public putData(url: string = this.putUri, id: string | number, changedObject: LU_STUnitOfMeasure) {
    // eslint-disable-next-line eqeqeq
    if (changedObject.lastModifiedDateTime == null) {
      changedObject.lastModifiedDateTime = new Date();
    }
    return super.putData(url, id, changedObject);
  }

  constructor(private _http: HttpClient, private _webAPI: WebApiService) {
    super(_http, _webAPI);
  }
}
